





















































import { LeadService } from "@/services/lead.service";
import DatePickerCalendar from "@/shared/components/date-picker-calendar.vue";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { required } from "@/shared/validators";
import moment from "moment";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ComboEtapaLead from "../components/ComboEtapaLead.vue";
import ComboTipoLead from "../components/ComboTipoLead.vue";

@Component({
  components: { Modal, DatePickerCalendar, ComboTipoLead, ComboEtapaLead },
})
export default class ExportarOctadesk extends mixins(GlobalMixin) {
  idTipoLead: number | null = null;
  periodoInicial: string | null = null;
  periodoFinal: string | null = null;
  arquivo: File | null = null;
  idEtapaLead: number | null = null;
  loading = false;

  rules = {
    periodoInicial: [required()],
    periodoFinal: [required()],
    idEtapaLead: [required()],
    idTipoLead: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async exportarOctadesk() {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async salvarExportacao() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      try {
        await LeadService.exportarLead(
          moment(this.periodoInicial!, "DD/MM/YYYY").toDate(),
          moment(this.periodoFinal!, "DD/MM/YYYY").toDate(),
          this.idEtapaLead!,
          this.idTipoLead!
        );

        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
